



































































































import { ValidationProvider } from "vee-validate";
import { Component, Vue, Prop, Emit, Watch, Ref } from "vue-property-decorator";

@Component({
    components: {
        ValidationProvider
    }
})
export default class FormCheckbox extends Vue {
    @Prop() name?: string;

    @Prop() value?: boolean;

    @Prop() label?: string;

    @Prop() labelText?: string;

    @Prop() rules?: string | object;

    @Prop({ default: false }) disabled!: boolean;

    @Ref() input!: HTMLInputElement;

    @Ref() readonly provider!: InstanceType<typeof ValidationProvider>;

    localValue = false;

    get hasLabelSlot() {
        return !!this.$slots.label;
    }

    private get checked(): boolean {
        return this.localValue ? this.localValue : false;
    }

    private set checked(val: boolean) {
        this.localValue = val;
    }

    private get formValdiated(): boolean {
        //@ts-ignore
        return this.provider.$_veeObserver?.flags?.validated;
    }

    private get validateAs(): string {
        if (this.label) {
            return this.label;
        }

        if (this.labelText) {
            return this.labelText;
        }

        if (this.name) {
            return this.name;
        }

        return "checkbox field";
    }

    @Emit("input")
    private handleInput() {
        return this.localValue;
    }

    @Emit("focus")
    private handleFocus(e: Event): Event {
        return e;
    }

    @Watch("value", { immediate: true })
    private valueChanged(newValue: boolean) {
        this.localValue = newValue;
    }
}
